// Verde vocabulary expansion — HOUSE & HOME theme (net-new cards).
//
// Extends the `house` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `spanish`, so every value is unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_HOUSE = [
  {
    theme: "house", tier: "A1", rows: [
      ["la habitación", "room", "🚪", "noun", "f", "Mi habitación es pequeña.", "My room is small."],
      ["la pared", "wall", "🧱", "noun", "f", "La pared es blanca.", "The wall is white."],
      ["el espejo", "mirror", "🪞", "noun", "m", "Me miro en el espejo.", "I look at myself in the mirror."],
      ["la llave", "key", "🔑", "noun", "f", "No encuentro la llave.", "I can't find the key."],
      ["el plato", "plate", "🍽️", "noun", "m", "El plato está sucio.", "The plate is dirty."],
      ["el vaso", "glass", "🥛", "noun", "m", "Quiero un vaso de agua.", "I want a glass of water."],
      ["la luz", "light", "💡", "noun", "f", "Apaga la luz, por favor.", "Turn off the light, please."],
      ["la ducha", "shower", "🚿", "noun", "f", "La ducha está rota.", "The shower is broken."],
      ["limpiar", "to clean", "🧽", "verb", "", "Limpio la casa los sábados.", "I clean the house on Saturdays."],
      ["la planta baja", "ground floor", "🏢", "phrase", "", "Vivo en la planta baja.", "I live on the ground floor."],
    ],
  },
  {
    theme: "house", tier: "A2", rows: [
      ["el mueble", "piece of furniture", "🪑", "noun", "m", "Compramos un mueble nuevo.", "We bought a new piece of furniture."],
      ["la alfombra", "rug / carpet", "🧶", "noun", "f", "La alfombra es muy suave.", "The rug is very soft."],
      ["la cortina", "curtain", "🪟", "noun", "f", "Corre las cortinas.", "Draw the curtains."],
      ["el cajón", "drawer", "🗄️", "noun", "m", "Las llaves están en el cajón.", "The keys are in the drawer."],
      ["el grifo", "tap", "🚰", "noun", "m", "El grifo gotea.", "The tap is dripping."],
      ["el enchufe", "plug / socket", "🔌", "noun", "m", "No hay enchufe cerca.", "There's no socket nearby."],
      ["el lavabo", "sink", "🧼", "noun", "m", "El lavabo está atascado.", "The sink is blocked."],
      ["la lavadora", "washing machine", "🧺", "noun", "f", "Pongo la lavadora por la noche.", "I run the washing machine at night."],
      ["el horno", "oven", "🔥", "noun", "m", "El pan está en el horno.", "The bread is in the oven."],
      ["la terraza", "terrace / balcony", "🪴", "noun", "f", "Desayunamos en la terraza.", "We have breakfast on the terrace."],
    ],
  },
  {
    theme: "house", tier: "B1", rows: [
      ["el casero", "landlord", "🏠", "noun", "m", "El casero subió el alquiler.", "The landlord raised the rent."],
      ["el contrato de alquiler", "rental contract", "📄", "phrase", "", "Firmamos el contrato de alquiler.", "We signed the rental contract."],
      ["la fianza", "deposit", "💶", "noun", "f", "Pagué un mes de fianza.", "I paid a month's deposit."],
      ["la vivienda", "housing / dwelling", "🏘️", "noun", "f", "La vivienda es muy cara aquí.", "Housing is very expensive here."],
      ["los gastos", "expenses / bills", "🧾", "noun", "m", "Los gastos no están incluidos.", "Bills are not included."],
      ["reformar", "to renovate", "🔨", "verb", "", "Vamos a reformar la cocina.", "We're going to renovate the kitchen."],
      ["el desván", "attic", "🏚️", "noun", "m", "Guardamos cosas en el desván.", "We keep things in the attic."],
      ["el sótano", "basement", "🕳️", "noun", "m", "El sótano está húmedo.", "The basement is damp."],
      ["espacioso", "spacious", "📐", "adjective", "", "El salón es muy espacioso.", "The living room is very spacious."],
      ["la comunidad de vecinos", "residents' association", "👥", "phrase", "", "Pagamos la comunidad cada mes.", "We pay the residents' fee each month."],
    ],
  },
];
